import { HeroHeadContainer } from "components/HeroHead";
import { LARGE } from "shared/constants";
import { MaxWidth } from "components/MaxWidth";
import { MetaGrid } from "components/MetaGrid";
import { SrcSet } from "components/SrcSet";
import cx from "classnames";
import styles from "./ProjectHero.module.css";

export const ProjectHero = ({ type, title, lead, image, meta }) => (
  <div className={cx(styles.container, { [styles.noImage]: !image })}>
    <MaxWidth size={LARGE}>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <HeroHeadContainer type={type} />

          <h1 className={styles.title}>{title}</h1>
          {lead && <p className={styles.lead}>{lead}</p>}
        </div>

        {meta.length > 0 && (
          <div className={styles.meta}>
            <MetaGrid meta={meta} inverted inline />
          </div>
        )}

        {image && (
          <div className={styles.image}>
            <SrcSet
              alt={image.alt}
              sizes={[
                { minWidth: 1200, width: 640, ratio: 4 / 3 },
                { minWidth: 1100, width: 530, ratio: 4 / 3 },
                { minWidth: 1000, width: 480, ratio: 4 / 3 },
                { minWidth: 900, width: 430, ratio: 4 / 3 },
                { minWidth: 850, width: 400, ratio: 1 },
                { minWidth: 800, width: 850, ratio: 16 / 9 },
                { minWidth: 700, width: 800, ratio: 16 / 9 },
                { minWidth: 600, width: 700, ratio: 16 / 9 },
                { minWidth: 500, width: 600, ratio: 4 / 3 },
                { minWidth: 400, width: 500, ratio: 4 / 3 },
                { minWidth: 345, width: 400, ratio: 4 / 3 },
                { minWidth: 1, width: 345, ratio: 4 / 3 },
              ]}
              src={image.url}
            />
          </div>
        )}
      </div>
    </MaxWidth>
  </div>
);
